import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {

  static cpf(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    const digits = control.value.replace(/\D/g, '');

    if (digits.length !== 11) {
      return { cpfInvalido: true };
    }

    // Rejeita CPFs com todos os dígitos iguais (ex.: 11111111111)
    if (/^(\d)\1{10}$/.test(digits)) {
      return { cpfInvalido: true };
    }

    const base = digits.substring(0, 9);
    const digitoUm = CustomValidators.calcularDigitoVerificador(base, 10);
    const digitoDois = CustomValidators.calcularDigitoVerificador(base + digitoUm, 11);
    const cpfValido = digits === `${base}${digitoUm}${digitoDois}`;

    if (!cpfValido) {
      return { cpfInvalido: true };
    }

    return null;
  }

static telefone(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    const digits = control.value.replace(/\D/g, '');

    if (digits.length !== 10) {
      return { cpfInvalido: true };
    }

    return null;
  }

  static celular(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    const digits = control.value.replace(/\D/g, '');

    if (digits.length !== 11) {
      return { cpfInvalido: true };
    }

    return null;
  }

  private static calcularDigitoVerificador(valor: string, pesoInicial: number): number {
    let soma = 0;
    for (let i = 0; i < valor.length; i++) {
      soma += Number(valor.charAt(i)) * (pesoInicial - i);
    }

    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  }
}
